import React, {memo, useRef} from "react";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import AppSpinner from './AppSpinner';
import { Tooltip } from 'react-tooltip';
import '../styles/ProductOverviewWidget.css';
import 'react-tooltip/dist/react-tooltip.css';
import { format } from 'date-fns';
import { de } from 'date-fns/locale';

// Origins, für die beim Kachel-Klick der Performancegraph im Graph-Widget geöffnet wird
// (statt eines externen Direktlinks per openNewWebtab). Ergaenzen, wenn weitere Datenquellen
// Timeseries-faehig werden. Wird auch in App.jsx (addAllGraphs) importiert — single source of truth.
export const GRAPH_ORIGINS = ["synthetic", "syntheticGIT", "syntheticPERF", "AWS"];

const ProductOverviewWidget = (props) => {
       
    //console.log(props)

    /***
     *     __  ___      ___  ___  __  
     *    /__`  |   /\   |  |__  /__` 
     *    .__/  |  /~~\  |  |___ .__/ 
     *                                
     */

    /*
    const [scrollPosition, setScrollPosition] = React.useState(0);
    const myRef = useRef(null);
 
    const handleScroll = () => {
        const position = window.scrollY;
        setScrollPosition(position);
    };
    
    React.useEffect(() => {
        if (myRef.current) {
          myRef.current.scrollTop = scrollPosition;
        }
      }, [scrollPosition]);
*/   
    const [configMenuStatus, setConfigMenuStatus] = React.useState(false);   
    const [productsWithErrors, setProductsWithErrors] = React.useState(0)
    const [toggleAllProductStatus, setToggleAllProductStatus] = React.useState(false)
    const widgetOptionsCopy = useRef({});

    /* === SCROLL-PRESERVATION (Rollback: diesen Block, den useLayoutEffect weiter
     * unten und die ref/onScroll-Attribute am .productWidget--ContentWrap-Div
     * loeschen — alle drei Bloecke sind mit demselben Marker gekennzeichnet).
     *
     * Problem: bei jedem Socket-Tick werden productData und darauffolgend
     * widgetOptions neu gesetzt, wodurch die Cascade an Re-Renders die Browser-
     * Scroll-Position im .productWidget--ContentWrap verliert. useLayoutEffect
     * stellt sie synchron vor dem Repaint wieder her. Kein anderer Widget-
     * State/-Prop wird beruehrt.
     *
     * Wichtig: der `isProgrammaticScroll`-Flag unterscheidet zwischen User-Scroll
     * (dann Position speichern) und programmatischem Scroll-Reset via useLayoutEffect
     * inkl. Browser-Auto-Clamp beim Content-Wechsel (dann NICHT speichern, sonst wird
     * die tatsaechliche Position ueberschrieben). === */
    const contentRef = useRef(null);
    const scrollPosRef = useRef(0);
    const isProgrammaticScroll = useRef(false);
    const handleContentScroll = (e) => {
        if (isProgrammaticScroll.current) {
            isProgrammaticScroll.current = false;
            return;
        }
        scrollPosRef.current = e.currentTarget.scrollTop;
    };
    /* === CRITICAL-BADGE: Klick auf ein Badge scrollt an den Anfang der Liste.
     * (Die Liste wird ohnehin nach Status sortiert, damit stehen die betroffenen
     * Produkte immer oben.) Rollback: diese Funktion entfernen. */
    const scrollToTop = () => {
        const el = contentRef.current;
        if (el) {
            el.scrollTo({ top: 0, behavior: 'smooth' });
        }
    };
    /* === CRITICAL-BADGE END === */
    // Zweites Ref-Set fuer den ConfigMenu-Container. FillConfigMenu ist als lokale
    // Function-Component definiert; bei jedem Parent-Render entsteht eine neue
    // Referenz, wodurch React den Baum unmount/remount — der scrollTop startet
    // damit bei 0. Der useLayoutEffect unten stellt die letzte User-Position wieder
    // her (Refs ueberleben Remount, weil sie im Outer-Scope leben).
    const configRef = useRef(null);
    const configScrollPosRef = useRef(0);
    const isConfigProgrammaticScroll = useRef(false);
    const handleConfigScroll = (e) => {
        if (isConfigProgrammaticScroll.current) {
            isConfigProgrammaticScroll.current = false;
            return;
        }
        configScrollPosRef.current = e.currentTarget.scrollTop;
    };
    /* === SCROLL-PRESERVATION END === */
    const [widgetOptions, setWidgetOptions] = React.useState(() => {
        
        if(props.productData !== undefined && props.productData.length > 0){

            let usedIndex = -1

            props.savedOptionsArray.forEach(function(widget, index) {
                
                if(widget.i !== undefined){
                    let string = widget.i
                    let subBefore= string.substring(0, string.indexOf('_'));
                    
                    if(subBefore === "productoverview"){
                        usedIndex = index;
                    } 
                }
            })
            

            let tmpShowErrorOnly = false
            let tmpShowAWS = false
            let tmpShowSynthetic = true
            let tmpShowSyntheticPERF = true
            let tmpShowSyntheticGIT = true
            let tmpShowCheckMK = true
            let tmpShowGrafana = false
            let tmpShowGithub = false
            let tmpShowSonarcloud = false
            let tmpShowAtlassian = false
            let tmpShowDocker = false
            let tmpErrorSort = false

            if(props.savedOptionsArray[usedIndex].optionShowErrorOnly !== undefined){
                tmpShowErrorOnly = props.savedOptionsArray[usedIndex].optionShowErrorOnly
            } 

            if(props.savedOptionsArray[usedIndex].optionShowAWS !== undefined){
                tmpShowAWS = props.savedOptionsArray[usedIndex].optionShowAWS
            } 

            if(props.savedOptionsArray[usedIndex].optionShowSynthetic !== undefined){
                tmpShowSynthetic = props.savedOptionsArray[usedIndex].optionShowSynthetic
            } 

            if(props.savedOptionsArray[usedIndex].optionShowSyntheticPERF !== undefined){
                tmpShowSyntheticPERF = props.savedOptionsArray[usedIndex].optionShowSyntheticPERF
            }             

            if(props.savedOptionsArray[usedIndex].optionShowSyntheticGIT !== undefined){
                tmpShowSyntheticGIT = props.savedOptionsArray[usedIndex].optionShowSyntheticGIT
            } 

            if(props.savedOptionsArray[usedIndex].optionShowCheckMK !== undefined){
                tmpShowCheckMK = props.savedOptionsArray[usedIndex].optionShowCheckMK
            } 
            
            if(props.savedOptionsArray[usedIndex].optionShowGrafana !== undefined){
                tmpShowGrafana = props.savedOptionsArray[usedIndex].optionShowGrafana
            } 
            
            if(props.savedOptionsArray[usedIndex].optionShowGithub !== undefined){
                tmpShowGithub = props.savedOptionsArray[usedIndex].optionShowGithub
            } 
            
            if(props.savedOptionsArray[usedIndex].optionShowSonarcloud !== undefined){
                tmpShowSonarcloud = props.savedOptionsArray[usedIndex].optionShowSonarcloud
            } 
            
            if(props.savedOptionsArray[usedIndex].optionShowAtlassian !== undefined){
                tmpShowAtlassian = props.savedOptionsArray[usedIndex].optionShowAtlassian
            } 
            
            if(props.savedOptionsArray[usedIndex].optionShowDocker !== undefined){
                tmpShowDocker = props.savedOptionsArray[usedIndex].optionShowDocker
            } 
            
            if(props.savedOptionsArray[usedIndex].optionErrorSort !== undefined){
                tmpErrorSort = props.savedOptionsArray[usedIndex].optionErrorSort
            }             

            let options = {
                i: props.id,
                
                optionShowErrorOnly: props.savedOptionsArray[usedIndex].optionShowErrorOnly,
                optionShowAWS: props.savedOptionsArray[usedIndex].optionShowAWS,
                optionShowSynthetic: props.savedOptionsArray[usedIndex].optionShowSynthetic,
                optionShowSyntheticPERF: props.savedOptionsArray[usedIndex].optionShowSyntheticPERF,
                optionShowSyntheticGIT: props.savedOptionsArray[usedIndex].optionShowSyntheticGIT,
                optionShowCheckMK: props.savedOptionsArray[usedIndex].optionShowCheckMK,
                optionShowGrafana: props.savedOptionsArray[usedIndex].optionShowGrafana,
                optionShowGithub: props.savedOptionsArray[usedIndex].optionShowGithub,
                optionShowSonarcloud: props.savedOptionsArray[usedIndex].optionShowSonarcloud,
                optionShowAtlassian: props.savedOptionsArray[usedIndex].optionShowAtlassian,
                optionShowDocker: props.savedOptionsArray[usedIndex].optionShowDocker,

                optionErrorSort: props.savedOptionsArray[usedIndex].optionErrorSort,
                visibleTests: []
            };
            
            props.productData.forEach(function(product) {
                
                let testVisibleStatus = false;
                let productVisibleStatus = true;

                if(props.savedOptionsArray[usedIndex].visibleTests !== undefined){
                    const currentProductIndexInOptions = props.savedOptionsArray[usedIndex].visibleTests.findIndex((product2) => product2.key === product._id);

                    if(currentProductIndexInOptions !== -1){
                        testVisibleStatus = props.savedOptionsArray[usedIndex].visibleTests[currentProductIndexInOptions].testVisible
                        productVisibleStatus = props.savedOptionsArray[usedIndex].visibleTests[currentProductIndexInOptions].productVisible
                    } 
                    
                }

                let originOptions = {
                    name: product.displayName,
                    key: product._id,
                    testVisible: testVisibleStatus,
                    productVisible: productVisibleStatus,
                    status: product.status,
                    description: product.description,
                    tests: product.tests  
                };
                
                options.visibleTests.push(originOptions);
                
            });         

            return options;
        } 
    });    

    const [showErrorOnly, setShowErrorOnly] = React.useState(() => {

        let usedIndex = -1

        props.savedOptionsArray.forEach(function(widget, index) {

            if(widget.i !== undefined){
                let string = widget.i
                let subBefore= string.substring(0, string.indexOf('_'));
                
                if(subBefore === "productoverview"){
                    usedIndex = index;
                } 
            }
        })

        if(props.savedOptionsArray[usedIndex].optionShowErrorOnly !== undefined){
            return props.savedOptionsArray[usedIndex].optionShowErrorOnly
        } else {
            return false
        }        
    })              

    const [showAWS, setShowAWS] = React.useState(() => {
        let usedIndex = -1
        
        props.savedOptionsArray.forEach(function(widget, index) {
            
            if(widget.i !== undefined){
                let string = widget.i
                let subBefore= string.substring(0, string.indexOf('_'));
                
                if(subBefore === "productoverview"){
                    usedIndex = index;
                } 
            }
        })

        if(props.savedOptionsArray[usedIndex].optionShowAWS !== undefined){
            return props.savedOptionsArray[usedIndex].optionShowAWS
        } else {
            return true
        }                
    }) 

    const [showSynthetic, setShowSynthetic] = React.useState(() => {
        let usedIndex = -1
        
        props.savedOptionsArray.forEach(function(widget, index) {
            
            if(widget.i !== undefined){
                let string = widget.i
                let subBefore= string.substring(0, string.indexOf('_'));
                
                if(subBefore === "productoverview"){
                    usedIndex = index;
                } 
            }
        })

        if(props.savedOptionsArray[usedIndex].optionShowSynthetic !== undefined){
            return props.savedOptionsArray[usedIndex].optionShowSynthetic
        } else {
            return true
        }                
    })         

    const [showSyntheticPERF, setShowSyntheticPERF] = React.useState(() => {
        let usedIndex = -1
        
        props.savedOptionsArray.forEach(function(widget, index) {
            
            if(widget.i !== undefined){
                let string = widget.i
                let subBefore= string.substring(0, string.indexOf('_'));
                
                if(subBefore === "productoverview"){
                    usedIndex = index;
                } 
            }
        })

        if(props.savedOptionsArray[usedIndex].optionShowSyntheticPERF !== undefined){
            return props.savedOptionsArray[usedIndex].optionShowSyntheticPERF
        } else {
            return true
        }                
    })     

    const [showSyntheticGIT, setShowSyntheticGIT] = React.useState(() => {
        let usedIndex = -1
        
        props.savedOptionsArray.forEach(function(widget, index) {
            
            if(widget.i !== undefined){
                let string = widget.i
                let subBefore= string.substring(0, string.indexOf('_'));
                
                if(subBefore === "productoverview"){
                    usedIndex = index;
                } 
            }
        })

        if(props.savedOptionsArray[usedIndex].optionShowSyntheticGIT !== undefined){
            return props.savedOptionsArray[usedIndex].optionShowSyntheticGIT
        } else {
            return true
        }                
    })     
    
    const [showCheckMk, setShowCheckMk] = React.useState(() => {
        let usedIndex = -1

        props.savedOptionsArray.forEach(function(widget, index) {

            if(widget.i !== undefined){
                let string = widget.i
                let subBefore= string.substring(0, string.indexOf('_'));
                
                if(subBefore === "productoverview"){
                    usedIndex = index;
                }             
            }
        })

        if(props.savedOptionsArray[usedIndex].optionShowCheckMK !== undefined){
            return props.savedOptionsArray[usedIndex].optionShowCheckMK
        } else {
            return true
        }        
    })          
    
    
    const [showGrafana, setShowGrafana] = React.useState(() => {
        let usedIndex = -1

        props.savedOptionsArray.forEach(function(widget, index) {
            if(widget.i !== undefined){
                let string = widget.i
                let subBefore= string.substring(0, string.indexOf('_'));
                
                if(subBefore === "productoverview"){
                    usedIndex = index;
                }             
            }
        })

        if(props.savedOptionsArray[usedIndex].optionShowGrafana !== undefined){
            return props.savedOptionsArray[usedIndex].optionShowGrafana
        } else {
            return false
        }              
    })         
    


    const [showGithub, setShowGithub] = React.useState(() => {
        let usedIndex = -1

        props.savedOptionsArray.forEach(function(widget, index) {

            if(widget.i !== undefined){
                let string = widget.i
                let subBefore= string.substring(0, string.indexOf('_'));
                
                if(subBefore === "productoverview"){
                    usedIndex = index;
                } 
            }
        })

        if(props.savedOptionsArray[usedIndex].optionShowGithub !== undefined){
            return props.savedOptionsArray[usedIndex].optionShowGithub
        } else {
            return false
        }              
    }) 

    const [showSonarcloud, setShowSonarcloud] = React.useState(() => {
        let usedIndex = -1

        props.savedOptionsArray.forEach(function(widget, index) {

            if(widget.i !== undefined){
                let string = widget.i
                let subBefore= string.substring(0, string.indexOf('_'));
                
                if(subBefore === "productoverview"){
                    usedIndex = index;
                }                 
            }
        })

        if(props.savedOptionsArray[usedIndex].optionShowSonarcloud !== undefined){
            return props.savedOptionsArray[usedIndex].optionShowSonarcloud
        } else {
            return false
        }              
    }) 

    const [showAtlassian, setShowAtlassian] = React.useState(() => {
        let usedIndex = -1

        props.savedOptionsArray.forEach(function(widget, index) {

            if(widget.i !== undefined){
                let string = widget.i
                let subBefore= string.substring(0, string.indexOf('_'));
                
                if(subBefore === "productoverview"){
                    usedIndex = index;
                }                 
            }
        })

        if(props.savedOptionsArray[usedIndex].optionShowAtlassian !== undefined){
            return props.savedOptionsArray[usedIndex].optionShowAtlassian
        } else {
            return false
        }              
    }) 

    const [showDocker, setShowDocker] = React.useState(() => {
        let usedIndex = -1

        props.savedOptionsArray.forEach(function(widget, index) {

            if(widget.i !== undefined){
                let string = widget.i
                let subBefore= string.substring(0, string.indexOf('_'));
                
                if(subBefore === "productoverview"){
                    usedIndex = index;
                }                 
            }
        })

        if(props.savedOptionsArray[usedIndex].optionShowDocker !== undefined){
            return props.savedOptionsArray[usedIndex].optionShowDocker
        } else {
            return false
        }              
    })     
    
    const [errorSort, setErrorSort] = React.useState(() => {
        let usedIndex = -1

        props.savedOptionsArray.forEach(function(widget, index) {

            if(widget.i !== undefined){
                let string = widget.i
                let subBefore= string.substring(0, string.indexOf('_'));
                
                if(subBefore === "productoverview"){
                    usedIndex = index;
                }             
            }
        })

        if(props.savedOptionsArray[usedIndex].optionErrorSort !== undefined){
            return props.savedOptionsArray[usedIndex].optionErrorSort
        } else {
            return false
        }           
    })                                     
    const [optionHasChanged, setOptionHasChanged] = React.useState(false)                                 

    const [isLoaded, setIsLoaded] = React.useState(false);                                       // Indikator ob Daten geladen wurden.       
    const [hasError, setHasError] = React.useState(false);                                      // Indikator ob Fehler vorliegen

    /* === CRITICAL-BADGE: Counts direkt aus State abgeleitet (useMemo). Bewusst NICHT
     * als useState + useEffect, weil der Zaehl-useEffect bei Toggle-Interaktionen
     * (die widgetOptions aendern, aber nicht in dessen Deps stehen) einen Zwischen-
     * zustand mit counts=0 durchlaufen konnte, sodass Badges kurzzeitig verschwanden.
     * useMemo berechnet die Counts synchron waehrend jedem Render — keine Race-Fenster.
     * Position: NACH allen useState-Deklarationen (showAWS, showSynthetic, ...) weil
     * useMemo synchron laeuft und die Referenzen sonst in der Temporal Dead Zone waeren. */
    const criticalBadgeCounts = React.useMemo(() => {
        let warn = 0, critical = 0, downtime = 0;
        if (!Array.isArray(props.productData) || !Array.isArray(widgetOptions?.visibleTests)) {
            return { warn, critical, downtime };
        }
        const visibleMap = new Map(widgetOptions.visibleTests.map(v => [v.key, v]));
        props.productData.forEach(product => {
            if (!visibleMap.has(product._id)) return;
            const tests = product.tests || [];
            const has = (o) => tests.some(t => t.origin === o);
            let showProduct = false;
            if (showSynthetic && has('synthetic')) showProduct = true;
            else if (showSyntheticPERF && has('syntheticPERF')) showProduct = true;
            else if (showSyntheticGIT && has('syntheticGIT')) showProduct = true;
            else if (showCheckMk && has('checkmk')) showProduct = true;
            else if (showGrafana && has('grafana')) showProduct = true;
            else if (showGithub && has('github')) showProduct = true;
            else if (showSonarcloud && has('sonarcloud')) showProduct = true;
            else if (showAtlassian && has('atlassian')) showProduct = true;
            else if (showDocker && has('docker')) showProduct = true;
            else if (showAWS && has('AWS')) showProduct = true;
            if (!showProduct) return;
            const s = product.status;
            if (s === 'WARN') warn++;
            else if (s === 'ERROR' || s === 'CRIT') critical++;
            else if (s === 'DOWN') downtime++;
        });
        return { warn, critical, downtime };
    }, [props.productData, widgetOptions, showAWS, showSynthetic, showSyntheticPERF, showSyntheticGIT, showCheckMk, showGrafana, showGithub, showSonarcloud, showAtlassian, showDocker]);
    /* === CRITICAL-BADGE END === */



    /***
     *          __   ___     ___  ___  ___  ___  __  ___  __  
     *    |  | /__` |__     |__  |__  |__  |__  /  `  |  /__` 
     *    \__/ .__/ |___    |___ |    |    |___ \__,  |  .__/ 
     *                                                        
     */

    /**
     * Hilfsvriable befüllen, damit in den Optionen die Reihenfolge der Produkte nicht beim re-render 
     * verändert wird
     */
    React.useEffect(() => {
        widgetOptionsCopy.current = widgetOptions;
    },[])

    // Wenn in den Props neue Daten vorliegen, wird der visibleTest State neu erstellt, um die Komponenten neu zu rendern
    React.useEffect(() => {
        
        let test = [];
        let countProducts = 0; 

        //console.log(props.productData)
        props.productData.forEach(function(product) {

            const currentProductIndex = widgetOptions.visibleTests.findIndex((product2) => product2.key === product._id);

            let originProduct = {
                name: product.displayName,
                key: product._id,
                testVisible: widgetOptions.visibleTests[currentProductIndex]['testVisible'],
                productVisible: widgetOptions.visibleTests[currentProductIndex]['productVisible'],
                status: product.status,  
                description: product.description,
                tests: product.tests                
            };

            test.push(originProduct);
        })
        

        // Check wieviele Produkte im error only angezeigt werden sollen
        widgetOptions.visibleTests.forEach(function(product){            

            const currentProductIndex = props.productData.findIndex((product2) => product2._id === product.key);

            if(currentProductIndex !== -1){
                let hasAWS = false
                let hasSynthetic = false
                let hasSyntheticPERF = false
                let hasSyntheticGIT = false
                let hasCheckMK = false
                let hasGrafana = false
                let showProduct = false
                let hasGithub = false
                let hasSonarcloud = false
                let hasAtlassian = false
                let hasDocker = false

                const foundAWS = product.tests.find(testsItem => testsItem.origin === "AWS");
                if (foundAWS){
                    hasAWS = true
                }

                const foundSynthetic = product.tests.find(testsItem => testsItem.origin === "synthetic");
                if (foundSynthetic){
                    hasSynthetic = true
                }

                const foundSyntheticPERF = product.tests.find(testsItem => testsItem.origin === "syntheticPERF");
                if (foundSyntheticPERF){
                    hasSyntheticPERF = true
                }

                const foundSyntheticGIT = product.tests.find(testsItem => testsItem.origin === "syntheticGIT");
                if (foundSyntheticGIT){
                    hasSyntheticGIT = true
                }

                const foundCheckMK = product.tests.find(testsItem => testsItem.origin === "checkmk");
                if (foundCheckMK){
                    hasCheckMK = true
                }        

                const foundGrafana = product.tests.find(testsItem => testsItem.origin === "grafana");
                if (foundGrafana){
                    hasGrafana = true
                }        

                const foundGithub = product.tests.find(testsItem => testsItem.origin === "github");
                if (foundGithub){
                    hasGithub = true
                }        
                
                const foundSonarcloud = product.tests.find(testsItem => testsItem.origin === "sonarcloud");
                if (foundSonarcloud){
                    hasSonarcloud = true
                }                

                const foundAtlassian = product.tests.find(testsItem => testsItem.origin === "atlassian");
                if (foundAtlassian){
                    hasAtlassian = true
                }          

                const foundDocker = product.tests.find(testsItem => testsItem.origin === "docker");
                if (foundDocker){
                    hasDocker = true
                }          
                
                if(showSynthetic === true && hasSynthetic === true){
                    showProduct = true
                } else if(showSyntheticPERF === true && hasSyntheticPERF === true){
                    showProduct = true
                } else if(showSyntheticGIT === true && hasSyntheticGIT === true){
                    showProduct = true
                } else if(showCheckMk === true && hasCheckMK === true){
                    showProduct = true
                } else if(showGrafana === true && hasGrafana === true){
                    showProduct = true
                } else if(showGithub === true && hasGithub === true){
                    showProduct = true
                } else if(showSonarcloud === true && hasSonarcloud === true){
                    showProduct = true
                } else if(showAtlassian === true && hasAtlassian === true){
                    showProduct = true
                } else if(showDocker === true && hasDocker === true){
                    showProduct = true
                } else if(showAWS === true && hasAWS === true){
                    showProduct = true
                } 
            
            
                if(props.productData[currentProductIndex].status !== "OK" && showProduct === true){
                    countProducts = countProducts + 1;   
                    setProductsWithErrors(countProducts)
                }  else {
                    //console.log(countProducts)
                    if(countProducts === 0){
                        setProductsWithErrors(countProducts)
                    }
                }              
            }
        })




        //console.log("test array: ")
        //console.log(test)

        if(errorSort){

            const sortOrder = ["ERROR", "WARN", "DOWN", "OK"];
            let strAscending = test.sort((a, b) => sortOrder.indexOf(a.status) - sortOrder.indexOf(b.status));

            strAscending.forEach((product) => {product.tests.sort(
                (a, b) => sortOrder.indexOf(a.status) - sortOrder.indexOf(b.status));
            });

            setWidgetOptions({ ...widgetOptions, visibleTests: strAscending });
            setIsLoaded(true)  

        } else {

            setWidgetOptions({ ...widgetOptions, visibleTests: test });
            setIsLoaded(true)

        }       
        
      }, [props, showErrorOnly, errorSort]);


      React.useEffect(() => {
        
        if(optionHasChanged === true){
            //console.log("Option has changed in Productoverview")
            props.syncOptionsArray(props.id, widgetOptions)
            setOptionHasChanged(false)
        } else {
            //console.log("No Option has been changed in Productoverview")
        }
                
      }, [widgetOptions]);


    /***
     *     ___            __  ___    __        __  
     *    |__  |  | |\ | /  `  |  | /  \ |\ | /__` 
     *    |    \__/ | \| \__,  |  | \__/ | \| .__/ 
     *                                             
     */

     
    const toggleConfigMenuStatus = () => {
        setConfigMenuStatus(!configMenuStatus)
    }

    const handleClickDummy = (Message) => {
        props.handleNotify({type: 'success', message: Message})
    };

    const handleAddGraph = (test, product, displayName, productName, type, origin) => {
        console.log("handleFunction displayname: " + displayName)
        console.log("handleFunction test: " + test)
        if(type !== 'all'){
            props.handleAddGraph(test, product, displayName, productName, type, origin);
        } else {
            props.handleAddGraph(test, product, displayName, productName, type, origin);
        }
        
    };    

    const toggleErrorOnly = () => {
        setWidgetOptions({ ...widgetOptions, optionShowErrorOnly: !widgetOptions.optionShowErrorOnly });
        setShowErrorOnly(!showErrorOnly)
        setOptionHasChanged(true)
        //console.log("Show Error Only: " + showErrorOnly)
    }

    const toggleShowAWS = () => {
        setWidgetOptions({ ...widgetOptions, optionShowAWS: !widgetOptions.optionShowAWS });
        setShowAWS(!showAWS)
        setOptionHasChanged(true)
        //console.log("Show Error Only: " + showErrorOnly)
    }

    const toggleShowSynthetic = () => {
        setWidgetOptions({ ...widgetOptions, optionShowSynthetic: !widgetOptions.optionShowSynthetic });
        setShowSynthetic(!showSynthetic)
        setOptionHasChanged(true)
        //console.log("Show Error Only: " + showErrorOnly)
    }

    const toggleShowSyntheticPERF = () => {
        setWidgetOptions({ ...widgetOptions, optionShowSyntheticPERF: !widgetOptions.optionShowSyntheticPERF });
        setShowSyntheticPERF(!showSyntheticPERF)
        setOptionHasChanged(true)
        //console.log("Show Error Only: " + showErrorOnly)
    }    

    const toggleShowSyntheticGIT = () => {
        setWidgetOptions({ ...widgetOptions, optionShowSyntheticGIT: !widgetOptions.optionShowSyntheticGIT });
        setShowSyntheticGIT(!showSyntheticGIT)
        setOptionHasChanged(true)
        //console.log("Show Error Only: " + showErrorOnly)
    }

    const toggleShowCheckMK = () => {
        setWidgetOptions({ ...widgetOptions, optionShowCheckMK: !showCheckMk });
        setShowCheckMk(!showCheckMk)
        setOptionHasChanged(true)
        //console.log("Show Error Only: " + showCheckMk)
    }
    
    const toggleGrafana = () => {
        setWidgetOptions({ ...widgetOptions, optionShowGrafana: !showGrafana });
        setShowGrafana(!showGrafana)
        setOptionHasChanged(true)
        //console.log("Show Grafana: " + showGrafana)
    }  

    const toggleGithub = () => {
        setWidgetOptions({ ...widgetOptions, optionShowGithub: !showGithub });
        setShowGithub(!showGithub)
        setOptionHasChanged(true)
    }  

    const toggleSonarcloud = () => {
        setWidgetOptions({ ...widgetOptions, optionShowSonarcloud: !showSonarcloud });
        setShowSonarcloud(!showSonarcloud)
        setOptionHasChanged(true)
    }  
    
    const toggleAtlassian = () => {
        setWidgetOptions({ ...widgetOptions, optionShowAtlassian: !showAtlassian });
        setShowAtlassian(!showAtlassian)
        setOptionHasChanged(true)
    }  
    
    const toggleDocker = () => {
        setWidgetOptions({ ...widgetOptions, optionShowDocker: !showDocker });
        setShowDocker(!showDocker)
        setOptionHasChanged(true)
    }      

    
    const toggleErrorSort = () => {        
        setWidgetOptions({ ...widgetOptions, optionErrorSort: !errorSort });
        setErrorSort(!errorSort) 
        setOptionHasChanged(true) 
    }
 
    /***********************************************************************************
     * DOM für das Konfigurationsmenü generieren 
     ***********************************************************************************/
    const FillConfigMenu = () => {
        // Anzeige-Verhalten (Gruppe A): reine UI-/Sort-Optionen
        const behaviorOptions = [
            { label: 'Alarme automatisch sortieren',            checked: !!errorSort,       onChange: toggleErrorSort },
            { label: 'Status OK ausblenden (Bad only)',         checked: !!showErrorOnly,   onChange: toggleErrorOnly },
        ];
        // Datenquellen (Gruppe B): Filter welche Alarm-/Test-Quellen im Widget berücksichtigt werden
        const sourceOptions = [
            { label: 'AWS-Alarme',                              checked: !!showAWS,          onChange: toggleShowAWS },
            { label: 'Synthetische Tests',                      checked: !!showSynthetic,    onChange: toggleShowSynthetic },
            { label: 'Synthetische Performance-Tests',          checked: !!showSyntheticPERF, onChange: toggleShowSyntheticPERF },
            { label: 'Synthetische GIT-Tests',                  checked: !!showSyntheticGIT, onChange: toggleShowSyntheticGIT },
            { label: 'CheckMK-Alarme',                          checked: !!showCheckMk,      onChange: toggleShowCheckMK },
            { label: 'Grafana-Alarme',                          checked: !!showGrafana,      onChange: toggleGrafana },
            { label: 'GitHub-Alarme',                           checked: !!showGithub,       onChange: toggleGithub },
            { label: 'Sonarcloud-Alarme',                       checked: !!showSonarcloud,   onChange: toggleSonarcloud },
            { label: 'Atlassian-Alarme',                        checked: !!showAtlassian,    onChange: toggleAtlassian },
            { label: 'Docker-Alarme',                           checked: !!showDocker,       onChange: toggleDocker },
        ];

        const productTotal   = widgetOptions?.visibleTests?.length || 0;
        const productVisible = (widgetOptions?.visibleTests || []).filter(t => t.productVisible).length;

        return (
            <div className="productWidget--configMenuWrap productWidgetConfig--Card">
                {/* Header — konsistent zu Detailwidget/Downtime: Titel + Close-Btn */}
                <div className="productWidget--HeaderWrap drag-handle productWidgetConfig--Header">
                    <div className="productWidgetConfig--HeaderTextWrap">
                        <span className="productWidgetConfig--HeaderMeta">PRODUKTÜBERSICHT</span>
                        <span className="productWidgetConfig--HeaderTitle">Widget-Konfiguration</span>
                    </div>
                    <button
                        type="button"
                        className="productWidgetHeader--MenuBtn productWidgetConfig--CloseBtn"
                        onClick={() => toggleConfigMenuStatus()}
                        aria-label="Konfiguration schließen"
                        title="Schließen"
                    >
                        <FontAwesomeIcon icon="fa-solid fa-xmark" />
                    </button>
                </div>

                {/* Scrollbarer Content-Bereich */}
                {/* SCROLL-PRESERVATION: ref + onScroll fuer ConfigMenu-Container */}
                <div className="productWidgetConfig--ContentWrap productWidgetConfig--Body" ref={configRef} onScroll={handleConfigScroll}>

                    {/* Section 1: Anzeige-Verhalten */}
                    <section className="productWidgetConfig--Section">
                        <div className="productWidgetConfig--SectionHead">
                            <div className="productWidgetConfig--SectionIcon" aria-hidden="true">
                                <FontAwesomeIcon icon="fa-solid fa-sliders" />
                            </div>
                            <div className="productWidgetConfig--SectionTitle">Anzeige</div>
                        </div>
                        <div className="productWidgetConfig--OptionList">
                            {behaviorOptions.map(opt => (
                                <label
                                    key={opt.label}
                                    className="productWidgetConfig--OptionRow"
                                >
                                    <span className="productWidgetConfig--OptionLabel">{opt.label}</span>
                                    <span className="switch productWidgetConfig--OptionSwitch">
                                        <input
                                            type="checkbox"
                                            onChange={opt.onChange}
                                            checked={opt.checked}
                                        />
                                        <span className="slider round"></span>
                                    </span>
                                </label>
                            ))}
                        </div>
                    </section>

                    {/* Section 2: Datenquellen */}
                    <section className="productWidgetConfig--Section">
                        <div className="productWidgetConfig--SectionHead">
                            <div className="productWidgetConfig--SectionIcon" aria-hidden="true">
                                <FontAwesomeIcon icon="fa-solid fa-database" />
                            </div>
                            <div className="productWidgetConfig--SectionTitle">Datenquellen</div>
                        </div>
                        <div className="productWidgetConfig--SectionSubtitle">Welche Alarm- und Test-Quellen werden angezeigt?</div>
                        <div className="productWidgetConfig--OptionList">
                            {sourceOptions.map(opt => (
                                <label
                                    key={opt.label}
                                    className="productWidgetConfig--OptionRow"
                                >
                                    <span className="productWidgetConfig--OptionLabel">{opt.label}</span>
                                    <span className="switch productWidgetConfig--OptionSwitch">
                                        <input
                                            type="checkbox"
                                            onChange={opt.onChange}
                                            checked={opt.checked}
                                        />
                                        <span className="slider round"></span>
                                    </span>
                                </label>
                            ))}
                        </div>
                    </section>

                    {/* Section 3: Produktauswahl */}
                    <section className="productWidgetConfig--Section">
                        <div className="productWidgetConfig--SectionHead">
                            <div className="productWidgetConfig--SectionIcon" aria-hidden="true">
                                <FontAwesomeIcon icon="fa-solid fa-list-check" />
                            </div>
                            <div className="productWidgetConfig--SectionTitle">Produktauswahl</div>
                            <div className="productWidgetConfig--SectionCounter" title="Sichtbare Produkte">
                                {productVisible}&nbsp;/&nbsp;{productTotal}
                            </div>
                        </div>
                        <div className="productWidgetConfig--SectionSubtitle">
                            Nur hier ausgewählte Produkte werden in der Übersicht dargestellt.
                        </div>
                        <div className="productWidgetConfig--BulkToggle" role="group" aria-label="Alle Produkte umschalten">
                            <button
                                type="button"
                                className={"productWidgetConfig--BulkBtn" + (!toggleAllProductStatus ? " productWidgetConfig--BulkBtn--Active" : "")}
                                onClick={() => toggleProductVisibility("off")}
                                aria-pressed={!toggleAllProductStatus}
                            >
                                <FontAwesomeIcon icon="fa-regular fa-eye" /> Alle anzeigen
                            </button>
                            <button
                                type="button"
                                className={"productWidgetConfig--BulkBtn" + (toggleAllProductStatus ? " productWidgetConfig--BulkBtn--Active" : "")}
                                onClick={() => toggleProductVisibility("on")}
                                aria-pressed={!!toggleAllProductStatus}
                            >
                                <FontAwesomeIcon icon="fa-regular fa-eye-slash" /> Alle ausblenden
                            </button>
                        </div>
                        <div className="productWidgetConfig--ProductList">
                            {(widgetOptions.visibleTests || []).map(originElement => {
                                const visible = !!originElement.productVisible;
                                return (
                                    <button
                                        type="button"
                                        key={originElement.key}
                                        className={"productWidgetConfig--ProductRow" + (visible ? "" : " productWidgetConfig--ProductRow--Off")}
                                        onClick={() => toggleProductVisibility(originElement.key)}
                                        aria-pressed={visible}
                                    >
                                        <span className="productWidgetConfig--ProductName">{originElement.name}</span>
                                        <span className="productWidgetConfig--ProductIcon" aria-hidden="true">
                                            <FontAwesomeIcon icon={visible ? "fa-regular fa-eye" : "fa-regular fa-eye-slash"} />
                                        </span>
                                    </button>
                                );
                            })}
                        </div>
                    </section>

                    {/* Persistenz-Hinweis */}
                    <div className="productWidgetConfig--Note">
                        <FontAwesomeIcon icon="fa-solid fa-circle-info" />
                        <span>Änderungen werden erst mit dem nächsten Dashboard-Speichern dauerhaft übernommen.</span>
                    </div>

                </div>

                {/* Footer: destruktive Widget-Loeschen-Aktion */}
                <div className="productWidgetConfig--DeleteWrap productWidgetConfig--Footer">
                    <button
                        type="button"
                        className="productWidgetHeader--DeleteBtn productWidgetConfig--DeleteBtn"
                        onClick={() => props.handleDelete(props.id)}
                    >
                        <FontAwesomeIcon icon="fa-solid fa-trash" />
                        <span>Widget entfernen</span>
                    </button>
                </div>
            </div>
        )
    }


    /*************************************************************************************
     * DOM für das Konfigurationsmenü generieren 
    *************************************************************************************/
    const FillProductContent = (product) => {
        //console.log(product)
        
        let productErorOnlyClass = "productWidget-productWrap";

        let hasAWS = false
        let hasSynthetic = false
        let hasSyntheticPERF = false        
        let hasSyntheticGIT = false
        let hasCheckMK = false
        let hasGrafana = false
        let showProduct = false
        let hasGithub = false
        let hasSonarcloud = false
        let hasAtlassian = false
        let hasDocker = false

        const foundAWS = product.product.tests.find(testsItem => testsItem.origin === "AWS");
        if (foundAWS){
            hasAWS = true
        }

        const foundSynthetic = product.product.tests.find(testsItem => testsItem.origin === "synthetic");
        if (foundSynthetic){
            hasSynthetic = true
        }

        const foundSyntheticPERF = product.product.tests.find(testsItem => testsItem.origin === "syntheticPERF");
        if (foundSyntheticPERF){
            hasSyntheticPERF = true
        }

        const foundSyntheticGIT = product.product.tests.find(testsItem => testsItem.origin === "syntheticGIT");
        if (foundSyntheticGIT){
            hasSyntheticGIT = true
        }

        const foundCheckMK = product.product.tests.find(testsItem => testsItem.origin === "checkmk");
        if (foundCheckMK){
            hasCheckMK = true
        }        

        const foundGrafana = product.product.tests.find(testsItem => testsItem.origin === "grafana");
        if (foundGrafana){
            hasGrafana = true
        }        

        const foundGithub = product.product.tests.find(testsItem => testsItem.origin === "github");
        if (foundGithub){
            hasGithub = true
        }        
        
        const foundSonarcloud = product.product.tests.find(testsItem => testsItem.origin === "sonarcloud");
        if (foundSonarcloud){
            hasSonarcloud = true
        }                

        const foundAtlassian = product.product.tests.find(testsItem => testsItem.origin === "atlassian");
        if (foundAtlassian){
            hasAtlassian = true
        }          

        const foundDocker = product.product.tests.find(testsItem => testsItem.origin === "docker");
        if (foundDocker){
            hasDocker = true
        }          
        
        if(showSynthetic === true && hasSynthetic === true){
            showProduct = true
        } else if(showSyntheticPERF === true && hasSyntheticPERF === true){
            showProduct = true
        } else if(showSyntheticGIT === true && hasSyntheticGIT === true){
            showProduct = true
        } else if(showCheckMk === true && hasCheckMK === true){
            showProduct = true
        } else if(showGrafana === true && hasGrafana === true){
            showProduct = true
        } else if(showGithub === true && hasGithub === true){
            showProduct = true
        } else if(showSonarcloud === true && hasSonarcloud === true){
            showProduct = true
        } else if(showAtlassian === true && hasAtlassian === true){
            showProduct = true
        } else if(showDocker === true && hasDocker === true){
            showProduct = true
        } else if(showAWS === true && hasAWS === true){
            showProduct = true
        } 

        // TODO weiter neue Origins einbauen. States erstellen, in Options einbinden und hier abfragen.
        // Neue graph-fähige Origins zusätzlich in GRAPH_ORIGINS (oben) ergänzen.

        if(showProduct === false){           
            productErorOnlyClass = "productWidget-productWrap productWidgetProduct-Hidden"
        } else if(showErrorOnly === true && product.product.status === "OK"){
            productErorOnlyClass = "productWidget-productWrap productWidgetProduct-Hidden"
        } else {
            productErorOnlyClass = "productWidget-productWrap"
        }
        
        const productStatusColorClass = "productWidgetProduct-Status productWidgetProduct-Status-" + product.product.status 
        const productName = product.product.name
        const productDescription = product.product.description
        return(
            <>
                {/* CRITICAL-BADGE: data-status auf dem Row-Wrapper, damit
                 * scrollToProductByStatus per querySelector das erste passende
                 * Produkt finden kann (Rollback: nur das data-status-Attribut entfernen) */}
                <div className={productErorOnlyClass} data-status={product.product.status}>
                    <div id={"productWidget-productBtnWrap"} className="productWidget-productBtnWrap" onClick={() => toggleProductTests(product.product.key)}>
                    {/*
                    <Tooltip    
                        className="tooltipStyles"
                        anchorSelect={"#productWidget-productBtnWrap"} 
                        html={productDescription} 
                        place="bottom" 
                        style={{ backgroundColor: "var(--hover-color)", color: "var(--text-color)" }}
                    /> */} 
                        <div className={productStatusColorClass}></div>
                        <div className="productWidgetProduct-Name">{product.product.name}</div>

                        {widgetOptions.visibleTests[productName] ? <div className="productWidgetProduct-TestBtn"><FontAwesomeIcon icon="fa-solid fa-chevron-up" /></div> 
                        : <div className="productWidgetProduct-TestBtn"><FontAwesomeIcon icon="fa-solid fa-chevron-down" /></div>}
                    </div>

                    <div className="break"></div>

                    {product.product.testVisible ? <FillTestContent key={"testContent-" + product.product.key} product={product} /> : null}
                    
                </div>
            </>
        )
    }    

    /*************************************************************************************
     * Befüllen der Testläufe eines Produkts
     * @param {*} product 
     * @returns 
     ************************************************************************************/
    const FillTestContent = (product) => {
        
        //console.log(product)
        // Ermitteln welche Origins bei den Test verwendet werden, und die Test entsprechenden Object unterordnen
        //console.log(product.product.product.tests)
        const tests = product.product.product.tests
        
        let sortedTests = []
        let counter = 0

        // Erstellen der Origins im Array
        tests.forEach(function(test) {
            
            let originTests = {
                origin: test.origin,
                key: counter,
                productId: test.productId,
                includedTests: []
            };
            
            // Alle Objekte prüfen ob das Origin bereits vorhanden ist
            const found = sortedTests.find(sortedTestsItem => sortedTestsItem.origin === test.origin);
            if (!found){
                sortedTests.push(originTests);
                counter = counter + 1;
            } 

        }); 


        // Zuweisen der Test zu den entsprechenden Origins
        tests.forEach(function(test) {
            
            sortedTests.forEach(function(sortedTests) {

                if(test.origin === sortedTests.origin){
                    sortedTests.includedTests = [...sortedTests.includedTests, test]   
                } 

            })
            
        }); 

        return(
            <>
                <div key={tests._id} className="productWidgetProduct-TestWrap">
                    
                    {sortedTests.map(originElement =>(  
                        <div key={"productWidgetProduct-" + originElement.key}>
                            <div key={originElement.key} className="productWidgetTests--HeaderWrap">
                                <div className="productWidgetTestsHeader--Title">{originElement.origin}</div>
                                
                                {GRAPH_ORIGINS.includes(originElement.origin) && (
                                    <>
                                        <div id={"tooltip-openAll"} className={"productWidgetTestsHeader--Btn productWidgetTestsHeader--Btn-" + originElement.origin} onClick={() => props.handleAddAllGraphs(originElement.origin, originElement.productId)}><FontAwesomeIcon icon="fa-solid fa-chart-line" /></div>
                                        <Tooltip    
                                            className="tooltipStyles"
                                            anchorSelect={"#tooltip-openAll"} 
                                            content={"Alle Testfälle öffnen"} 
                                            place="left" 
                                            style={{ backgroundColor: "var(--hover-color)", color: "var(--text-color)"}}
                                        />
                                    </>
                                )}
                            </div>
                            <div key={"productWidgetTestsHeader--Line" + originElement.key} className="productWidgetTestsHeader--Line"></div>
                            

                            {originElement.includedTests.map(test =>{
                                
                                if(showErrorOnly === true && test.status !== "OK"){

                                    if(GRAPH_ORIGINS.includes(test.origin)){
                                        return(
                                        <div id={"tooltip-" + test._id} key={"productWidgetTest-" + test._id} className="productWidgetTest--Container" onClick={() => handleAddGraph(test._id, originElement.productId, test.displayName, product.product.product.name, 'single', test.origin)}>
                                        <Tooltip    
                                            className="tooltipStyles"
                                            anchorSelect={"#tooltip-" + test._id} 
                                            place="bottom" 
                                            style={{ backgroundColor: "var(--hover-color)", color: "var(--text-color)"}}
                                        >
                                            <span dangerouslySetInnerHTML={{ __html: "<b>" + test.description + "</b><br /><br />" + (test.origin === 'AWS' ? "" : "Durchschnittsdauer: " + test.avgDuration + " sek. <br />Status der letzten 3 Durchläufe: " + test.countOk + "/3 OK<br /><br />") + "<b>Owner:</b> " + test.owner }} />
                                        </Tooltip>
                                            <div className="productWidgetTest--Name">{test.displayName}</div>                                    
                                            <div className="roductWidgetTest--Symbol"></div>
                                            <div className={"productWidgetTest--Status productWidgetProduct-Status-" + test.status}></div>
                                        </div>
                                        )
                                    } else {
                                        return(
                                            <div id={"tooltip-" + test._id} key={"productWidgetTest-" + test._id} className="productWidgetTest--Container" onClick={() => openNewWebtab(test.url)}>
                                            <Tooltip    
                                                className="tooltipStyles"
                                                anchorSelect={"#tooltip-" + test._id} 
                                                content={"Letzte Statusänderung: " + format(new Date(test.results[0].timestamp), 'dd.MM.yyyy HH:mm:ss', { locale: de })}
                                                place="bottom" 
                                                style={{ backgroundColor: "var(--hover-color)", color: "var(--text-color)" }}
                                            />
                                                <div className="productWidgetTest--Name">{test.displayName}</div>                                    
                                                <div className="roductWidgetTest--Symbol"></div>
                                                <div className={"productWidgetTest--Status productWidgetProduct-Status-" + test.status}></div>
                                            </div>
                                            )                                    
                                    }

                                } else if (showErrorOnly === false) {

                                    if(GRAPH_ORIGINS.includes(test.origin)){
                                        return(
                                        <div id={"tooltip-" + test._id} key={"productWidgetTest-" + test._id} className="productWidgetTest--Container" onClick={() => handleAddGraph(test._id, originElement.productId, test.displayName, product.product.product.name, 'single', test.origin)}>
                                        <Tooltip    
                                            className="tooltipStyles"
                                            anchorSelect={"#tooltip-" + test._id} 
                                            place="bottom" 
                                            style={{ backgroundColor: "var(--hover-color)", color: "var(--text-color)" }}
                                        >
                                            <span dangerouslySetInnerHTML={{ __html: "<b>" + test.description + "</b><br /><br />" + (test.origin === 'AWS' ? "" : "Durchschnittsdauer: " + test.avgDuration + " sek. <br />Status der letzten 3 Durchläufe: " + test.countOk + "/3 OK<br /><br />") + "<b>Owner:</b> " + test.owner }} />
                                        </Tooltip>
                                            <div className="productWidgetTest--Name">{test.displayName}</div>                                    
                                            <div className="roductWidgetTest--Symbol"></div>
                                            <div className={"productWidgetTest--Status productWidgetProduct-Status-" + test.status}></div>
                                        </div>
                                        )
                                    } else {
                                        
                                        return(
                                            <div id={"tooltip-" + test._id} key={"productWidgetTest-" + test._id} className="productWidgetTest--Container" onClick={() => openNewWebtab(test.url)}>
                                            <Tooltip    
                                                className="tooltipStyles"
                                                anchorSelect={"#tooltip-" + test._id} 
                                                content={"Letzte Statusänderung: " + format(new Date(test.results[0].timestamp), 'dd.MM.yyyy HH:mm:ss', { locale: de })}
                                                place="bottom" 
                                                style={{ backgroundColor: "var(--hover-color)", color: "var(--text-color)" }}
                                            />
                                                <div className="productWidgetTest--Name">{test.displayName}</div>                                    
                                                <div className="roductWidgetTest--Symbol"></div>
                                                <div className={"productWidgetTest--Status productWidgetProduct-Status-" + test.status}></div>
                                            </div>
                                            )                                    
                                    }

                                }
                                
                            })}

                            <div key={"productWidgetTests--Spacer" + originElement.key} className="productWidgetTests--Spacer"></div>
                        </div>
                    ))}

                    
                </div>
            </>
        )
    }

    const openNewWebtab = (url) => {

        if(url !== undefined && url !== ''){
            window.open(url, '_blank').focus();
        } else {
            props.handleNotify({type: 'warning', message: 'Für diesen Test ist keine Verlinkung hinterlegt.'})
        }
        
    }


    /**
     * Anzeigen der Test Wrapper zum zugehörigen Produkt
     * @param {*} product 
     */
    const toggleProductTests = (productID) => {
        // 1. Find the product with the provided id
        const currentProductIndex = widgetOptions.visibleTests.findIndex((product) => product.key === productID);
        // 2. Mark the testVisible as true or false
        const productValue = !widgetOptions.visibleTests[currentProductIndex]['testVisible']
        const updatedVisibleTests = {...widgetOptions.visibleTests[currentProductIndex], testVisible: productValue};
        // 3. Update the visibleTests
        const newVisibleTests = [...widgetOptions.visibleTests];
        newVisibleTests[currentProductIndex] = updatedVisibleTests;
        
        setWidgetOptions({ ...widgetOptions, visibleTests: newVisibleTests }); 
        setOptionHasChanged(true)            
    }


    /**
     * Funktion zum Ein und Ausblenden von einzelnen Produkten
     * @param {*} product
     */


    const toggleProductVisibility = (productID) => {
        
        if(productID === "on"){
            setToggleAllProductStatus(true)
            //console.log("Turn all off")

            let newProducts = [];
            widgetOptions.visibleTests.forEach(function(product) {                
                const updatedProduct = {...product, productVisible: false}; 
                newProducts.push(updatedProduct);                              
            }); 
            
            setWidgetOptions({ ...widgetOptions, visibleTests: newProducts });                       
            setOptionHasChanged(true)


        } else if(productID === "off"){
            setToggleAllProductStatus(false)
            //console.log("Turn all on")

            let newProducts = [];
            widgetOptions.visibleTests.forEach(function(product) {                
                const updatedProduct = {...product, productVisible: true}; 
                newProducts.push(updatedProduct);                              
            }); 
            
            setWidgetOptions({ ...widgetOptions, visibleTests: newProducts });                       
            setOptionHasChanged(true)

        } else {
            // 1. Find the product with the provided id
            const currentProductIndex = widgetOptions.visibleTests.findIndex((product) => product.key === productID);
            // 2. Mark the testVisible as true or false
            const productValue = !widgetOptions.visibleTests[currentProductIndex]['productVisible']
            const updatedVisibleTests = {...widgetOptions.visibleTests[currentProductIndex], productVisible: productValue};
            // 3. Update the visibleTests
            const newVisibleTests = [...widgetOptions.visibleTests];
            newVisibleTests[currentProductIndex] = updatedVisibleTests;
             
            setWidgetOptions({ ...widgetOptions, visibleTests: newVisibleTests });                                     
            setOptionHasChanged(true)
        }
    
    }    




    /***
     *     __   __            __   ___ ___       __       
     *    |  \ /  \  |\/|    |__) |__   |  |  | |__) |\ | 
     *    |__/ \__/  |  |    |  \ |___  |  \__/ |  \ | \| 
     *                                                    
     */

    /* === SCROLL-PRESERVATION (Rollback: siehe Marker oben) ===
     * useLayoutEffect laeuft SYNCHRON nach jedem DOM-Update, aber VOR dem Repaint
     * — dadurch schreibt er scrollTop zurueck bevor der User das "Springen"
     * ueberhaupt sieht. Kein Dep-Array = laeuft nach jedem Render (billig, weil
     * er nur schreibt wenn die Position wirklich abweicht).
     *
     * Der Flag `isProgrammaticScroll` markiert das nachfolgende scroll-Event als
     * Nicht-User-Input, damit `handleContentScroll` die gespeicherte Position nicht
     * ueberschreibt (siehe Kommentar im ref-Block). */
    React.useLayoutEffect(() => {
        const el = contentRef.current;
        if (el && scrollPosRef.current > 0 && el.scrollTop !== scrollPosRef.current) {
            isProgrammaticScroll.current = true;
            el.scrollTop = scrollPosRef.current;
        }
        const cfg = configRef.current;
        if (cfg && configScrollPosRef.current > 0 && cfg.scrollTop !== configScrollPosRef.current) {
            isConfigProgrammaticScroll.current = true;
            cfg.scrollTop = configScrollPosRef.current;
        }
    });
    /* === SCROLL-PRESERVATION END === */
    /* === SCROLL-PRESERVATION END === */

    return(
        <>
            {configMenuStatus ?  <FillConfigMenu /> : null}
            <div className="productWidget--HeaderWrap drag-handle">
                <div className="productWidgetHeader--Title">
                    <span className="productWidgetHeader--TitleText">Produktübersicht</span>
                    {/* === CRITICAL-BADGE: Badges liegen jetzt UNTER dem Titel (statt daneben),
                     * damit sie bei schmalen Widget-Breiten den Titel nicht aus dem Header
                     * schieben. Rollback: den BadgeRow-Wrapper entfernen und Badges wieder
                     * inline oberhalb rendern; onMouseDown-stopPropagation bleibt wichtig. === */}
                    {(criticalBadgeCounts.critical > 0 || criticalBadgeCounts.warn > 0 || criticalBadgeCounts.downtime > 0) && (
                    <div className="productWidgetHeader--BadgeRow">
                        {criticalBadgeCounts.critical > 0 && (
                            <span
                                className="productWidgetHeader--Badge productWidgetHeader--Badge--critical"
                                onMouseDown={(e) => e.stopPropagation()}
                                onClick={scrollToTop}
                                title="Zum Anfang der Liste scrollen"
                                aria-label={`${criticalBadgeCounts.critical} kritische Produkte`}
                            >{criticalBadgeCounts.critical}</span>
                        )}
                        {criticalBadgeCounts.warn > 0 && (
                            <span
                                className="productWidgetHeader--Badge productWidgetHeader--Badge--warn"
                                onMouseDown={(e) => e.stopPropagation()}
                                onClick={scrollToTop}
                                title="Zum Anfang der Liste scrollen"
                                aria-label={`${criticalBadgeCounts.warn} Produkte mit Warnung`}
                            >{criticalBadgeCounts.warn}</span>
                        )}
                        {criticalBadgeCounts.downtime > 0 && (
                            <span
                                className="productWidgetHeader--Badge productWidgetHeader--Badge--downtime"
                                onMouseDown={(e) => e.stopPropagation()}
                                onClick={scrollToTop}
                                title="Zum Anfang der Liste scrollen"
                                aria-label={`${criticalBadgeCounts.downtime} Produkte in Downtime`}
                            >{criticalBadgeCounts.downtime}</span>
                        )}
                    </div>
                    )}
                    {/* === CRITICAL-BADGE END === */}
                </div>
                <button
                    className="productWidgetHeader--MenuBtn"
                    onClick={() => toggleConfigMenuStatus()}
                >
                    <FontAwesomeIcon icon="fa-solid fa-ellipsis-vertical" />
                </button>
            </div>
            {/* SCROLL-PRESERVATION (Rollback: ref + onScroll entfernen, siehe Marker oben) */}
            <div className="productWidget--ContentWrap" ref={contentRef} onScroll={handleContentScroll}>

            {
                (() => {
                    if (isLoaded === false)
                        return(
                            <div className="productWidget--LoadingWrap">
                                <p className="productWidget--LoadingWrapText">Lade Daten</p>
                                <p><AppSpinner /></p>
                            </div> 
                        )

                    if (isLoaded === true){
                        let somethingVisible = false;
                        widgetOptions.visibleTests.forEach(function(product) {                
                            if(product.productVisible === true){
                                somethingVisible = true;
                            }
                        });
                        if(somethingVisible !== true){
                            return <div className="productWidget--ErrorWrap">Es sind keine Produkte ausgewählt</div>    
                        }                        
                    }
                                        
                    if (isLoaded === true && productsWithErrors === 0 && showErrorOnly === true)
                        return <div className="productWidget--ErrorWrap">Bei den ausgewählten Produkten sind <br />z.Zt. keine Alarme vorhanden</div>
                    if (hasError === true)
                        return <div className="productWidget--ErrorWrap">Error</div>
                    else 
                        return(
                            widgetOptions.visibleTests.map((position) => {
                                if(position.productVisible === true){

                                    return(
                                        <FillProductContent 
                                            key={position.key}   
                                            id={position.key} 
                                            product={position} 
                                        />
                                        // TODO ADD +1
                                    )                            
                                } else {
                                    return(
                                        <div key={position.key} ></div>
                                    )
                                }
                            })
                        )
                })()
            }


            </div>

        </>
    )

}

export default memo(ProductOverviewWidget)
